"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
exports.Container = (0, styled_1.default)('ul') `
  list-style: none;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;

  li {
    margin-right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  }

  // increase specificity over the @kyruus/button's PrimaryButton styles
  && {
    button {
      border-radius: 50%;
      padding: 0;
      width: ${(0, ui_theme_1.fromTheme)('spacing_large')};
      height: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    }
  }
`;
//# sourceMappingURL=styles.js.map